// extracted by mini-css-extract-plugin
module.exports = {"rowOfTwoSwiper":"RowOfTwo_rowOfTwoSwiper__oAWK_"};